/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/portfolio.preview.json";

import { toHeaderCase } from "js-convert-case";
export interface IPortfolioPreviewMethods extends IPluginMethodMap {
    getPortfolioPreviewContentSync(args: any): any;
}

function isValidHttpUrl(string: string) {
    let url;

    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }

    return url.protocol === "http:" || url.protocol === "https:";
}


export class PortfolioPreviewService implements IAgentPlugin {
    readonly methods: IPortfolioPreviewMethods;

    constructor() {
        this.methods = {
            getPortfolioPreviewContentSync: this.getProps.bind(this),
        };
    }

    getProps(args: any) {
        console.log(`args in portfolio preview component service`, args);
        let _preview: any = [];
        Array.isArray(args?.formData) && args?.formData?.forEach((item: any) => {
            let _credential = args?.credentialForm?.templates?.find(key => key?.credentialId === item?.id);
            _preview.push({
                logoSrc: _credential?.credentialLogo,
                title: _credential?.credentialName,
                subtitle: _credential?.credentialDescription,
                credential: this.formatAttributes(item),
                carouselItems: this.formatCarouselItems(item),
            })
        });
        return _preview;
    }

    private formatAttributes(credential?: any) {
        let _attributeData: any = [];
        let formatted: any = { ...(credential || {}) };
        if (formatted) {
            for (let key in formatted) {
                if (config?.credentialSubject?.blacklistedKeys?.includes(key)) {
                    delete formatted[key];
                }
            }
        }

        Object.entries(formatted).forEach(([key, value]) => {
            console.log(`type of value:`, (typeof value === 'object'));
            if (!Array.isArray(value) && !(typeof(value) === 'object')) {
                _attributeData.push({
                    label: toHeaderCase(key ?? ""),
                    value: value,
                });
            }
        });
        return _attributeData;
    }

    private formatCarouselItems(credential: any) {
        let _docs: any = [];
        if (credential?.pdf) {
            const src = isValidHttpUrl(credential?.pdf)
                ? credential?.pdf
                : `data:application/pdf;base64,${credential?.pdf}`;
            _docs.push({
                type: "pdf",
                poster: credential?.logo,
                src: src,
                title: credential?.credentialName,
            });
        }
         Object.entries(credential).forEach(([key, value]) => {
            if (Array.isArray(value) && value?.length > 0) {
                value.forEach(ele => {
                    if (ele?.type) {
                        let _type = ele?.type?.split("/");
                        _docs.push({
                            type: _type[0] === "image" ? "img" : _type[0] === "video" ? "video" : _type[0] === "audio" ? "audio" : "pdf",
                            poster: ele?.poster,
                            src: ele?.base64,
                            title: ele?.title?.replace(/\.[^/.]+$/, ""),
                        })
                    }
                })
            }
        })
        Array.isArray(credential?.evidence) &&
            credential?.evidence.map((item: any) => {
                let _type = item?.evidenceDocumentType?.split("/");
                _docs.push({
                    type: _type[0] === "image" ? "img" : _type[0] === "video" ? "video" : _type[0] === "audio" ? "audio" : "pdf",
                    poster: item?.poster,
                    src: item?.id,
                    title: item?.evidenceDocument?.replace(/\.[^/.]+$/, ""),
                });
            });
        return _docs;
    }
}